// src/utils/axios.js
import axios from 'axios'
import { useAuthStore } from '../stores/auth'
import router from '../router'

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://31.97.58.184:4002',
  timeout: 30000
})

// Interceptor request: tambahkan token ke setiap request
axiosInstance.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    if (authStore.token) {
      config.headers.Authorization = `Bearer ${authStore.token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Interceptor response: tangani error 401 (Token expired / invalid)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const authStore = useAuthStore()
      
      console.warn('401 Unauthorized - Token kadaluwarsa atau tidak valid')
      
      // Logout dan bersihkan state
      authStore.logout()
      
      // Redirect ke halaman login
      if (router.currentRoute.value.path !== '/login') {
        router.push('/login')
      }
      
      // Tampilkan notifikasi
      if (window.showNotification) {
        window.showNotification('Sesi Anda telah berakhir. Silakan login kembali.', 'error')
      } else {
        alert('Sesi Anda telah berakhir. Silakan login kembali.')
      }
    }
    return Promise.reject(error)
  }
)

export default axiosInstance